import { Component, OnInit, Input } from '@angular/core';
import { get } from 'lodash';

@Component({
  selector: 'app-hr',
  templateUrl: './hr.component.html',
  styleUrls: ['./hr.component.scss']
})
export class HrComponent implements OnInit {

  @Input() config: {
    margin?: {
      top?: number,
      bottom?: number
    };
    color?: string;
  };

  style: object = {
    'border-width': '1px'
  };

  constructor() { }

  ngOnInit() {
    this.style = {...this.style, ...this.getStyle()};
  }

  /**
   * [Method to set style to <hr> tag]
   * @task QLIKTAG-3341
   * @author Abhishek
   */
  getStyle() {
    let styleObj: object = {};

    if (this.config && this.config.hasOwnProperty("margin")) {
      if (this.config.margin.hasOwnProperty("top")) {
        styleObj['margin-top'] = this.getPxValue(this.config, 'margin.top')
      }

      if (this.config.margin.hasOwnProperty("bottom")) {
        styleObj['margin-bottom'] = this.getPxValue(this.config, 'margin.bottom')
      }
    }
    return styleObj;
  }

  /**
   * [Method to add "px" to value]
   * @param  obj  [input Object]
   * @param  path [path]
   * @param defaultValue [defaultValue]
   * @return value string with "px"
   * @task QLIKTAG-3341
   * @author Abhishek
   */
  getPxValue(obj, path, defaultValue= 0): string {
    let result = get(obj, path);

    return (result && result !== '') ? `${result}px` : `${defaultValue}px`;
  }

}
